import { listSummary } from '../presentation/list-copy'
import { validateSnapshot } from '@/ai/protocol/contract'
import { errorMessage } from '@/ai/services/api'

// 方法绑定到原页面实例；不持有独立状态、请求实例或生命周期。
export default {
  actionBody(turn, card) {
    const a = card.interaction
    return {
      sessionId: turn.sessionId,
      turnId: turn.turnId,
      actionId: a.actionId,
      actionToken: a.actionToken,
      expectedActionRevision: a.actionRevision
    }
  },
  cardRequestKey(turn, card) { return JSON.stringify([turn.sessionId, turn.turnId, card.id]) },
  async submitAction(turn, event) {
    if (this.busy || turn.blocked || turn.readOnly) return
    this.activeActionKey = this.cardRequestKey(turn, event.card)
    this.cardActionTurnId = turn.turnId
    this.actionSubmitting = true
    this.error = ''
    try {
      this.apply(
        await this.call('action/submit', {
          ...this.actionBody(turn, event.card),
          kind: event.kind,
          input: event.input
        })
      )
    } catch (error) {
      this.fail(error)
    } finally {
      this.actionSubmitting = false
      this.activeActionKey = null
      const current = this.turns.find(t => t.turnId === turn.turnId)
      if (current && !this.terminal(current)) this.schedule(current)
    }
  },
  async nextPage(turn, card) {
    if (this.busy || (!['device_cards', 'info_list', 'scene_cards'].includes(card.type) && (turn.blocked || turn.readOnly))) return
    const key = this.cardRequestKey(turn, card)
    this.$set(this.pagination, key, { loading: true, error: false })
    this.paging = true
    try {
      let component
      if (['device_cards', 'info_list', 'scene_cards'].includes(card.type)) {
        const page = await this.call('result/page', { sessionId: turn.sessionId, turnId: turn.turnId, revision: turn.revision, componentId: card.id, cursor: card.nextCursor })
        if (page.sessionId !== turn.sessionId || page.turnId !== turn.turnId || page.revision !== turn.revision || page.componentId !== card.id) throw new Error('WRONG_RESPONSE')
        component = { ...card, items: card.items.concat(page.items), hasMore: page.hasMore, nextCursor: page.nextCursor }
        if (['info_list','scene_cards'].includes(card.type)) {
          const unique = new Map(component.items.map(item => [item.id, item])); component.items = Array.from(unique.values())
          if (card.type === 'scene_cards') component.footerText = listSummary(component.items)
        }
        if (Number.isInteger(page.matchedTotal)) {
          // 状态查询按页读取服务端当前记录；状态变化导致重复引用时保留最近一次数据。
          const key = item => JSON.stringify([item.ref.regionId, item.ref.productId, item.ref.deviceId || null])
          const unique = new Map(component.items.map(item => [key(item), item]))
          component.items = Array.from(unique.values())
          component.matchedTotal = page.matchedTotal
          component.footerText = listSummary(component.items, page.matchedTotal)
          component.truncated = page.truncated
          component.notice = page.notice
        }
      } else {
        const page = await this.call('action/page', { ...this.actionBody(turn, card), cursor: card.nextCursor })
        if (card.executionMode === 'explicit') {
          if (page.actionId !== card.interaction.actionId || !page.turn || page.turn.sessionId !== turn.sessionId || page.turn.turnId !== turn.turnId || page.actionRevision <= card.interaction.actionRevision) throw new Error('WRONG_RESPONSE')
          this.apply(page.turn); return
        }
        if (page.actionId !== card.interaction.actionId || page.actionRevision !== card.interaction.actionRevision) throw new Error('WRONG_RESPONSE')
        component = page.component
      }
      const index = this.turns.findIndex(t => t.turnId === turn.turnId && t.revision === turn.revision)
      if (index < 0) return
      const replacement = { ...turn, components: turn.components.map(c => c.id === card.id ? component : c) }
      replacement.blocked = validateSnapshot(replacement).blocked
      this.$set(this.turns, index, replacement)
    } catch (error) {
      if (['TOKEN_ERROR', 'ACCOUNT_CHANGED', 'AI_DISABLED', 'AI_ROLE_DISABLED'].includes(error.message)) this.fail(error)
      else if (this._alive) this.$set(this.pagination, key, { loading: false, error: true, errorMessage: errorMessage(error, '') })
    } finally {
      if (this.pagination[key]) this.$set(this.pagination, key, { ...this.pagination[key], loading: false })
      this.paging = false
    }
  },
  async cancel() {
    if (!this.canStop || this.busy) return
    const turn = this.latest
    this.stopping = true
    this.error = ''
    clearTimeout(this._poll)
    this._pollEpoch = (this._pollEpoch || 0) + 1
    try {
      const result = await this.call('turn/cancel', { sessionId: turn.sessionId, turnId: turn.turnId })
      if (!this._alive || !this.session || this.session.sessionId !== turn.sessionId) return
      if (result.sessionId !== turn.sessionId || result.turnId !== turn.turnId) throw new Error('WRONG_RESPONSE')
      // Only the server can confirm cancellation; an already-dispatching action stays in progress.
      this.apply(result)
    } catch (error) {
      if (this._alive) this.fail(error)
    } finally {
      this.stopping = false
      if (this._alive) this.schedule(this.latest)
    }
  }
}
